import { environment } from '@environment';

/**GTM loading script */
export const gtm_script = `
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    // j.async = true;
    j.defered = true;
    j.setAttribute('rel', 'preconnect');
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    j.addEventListener('load', function() {
      var _ge = new CustomEvent('gtm_loaded', { bubbles: true });
      d.dispatchEvent(_ge);
    });
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', '${environment.gtm_id}');
`;
/**Clever Tap loading script */
export const clevertap_script = `
  var clevertap = {event:[], profile:[], account:[], onUserLogin:[], notifications:[], privacy:[], region: 'in1'};
  clevertap.account.push({"id": '${environment.clevertap_id}'});
  clevertap.privacy.push({optOut: false}); //set the flag to true, if the user of the device opts out of sharing their data
  clevertap.privacy.push({useIP: false}); //set the flag to true, if the user agrees to share their IP data
  (function () {
    var wzrk = document.createElement('script');
    wzrk.type = 'text/javascript';
    wzrk.async = true;
    wzrk.defered = true;
    wzrk.setAttribute('rel', 'preconnect');
    wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/clevertap.min.js';
    var s = document.getElementsByTagName('script')[0];
    s.addEventListener('load', function() {
      var _ct = new CustomEvent('ct_loaded', { bubbles: true });
      document.dispatchEvent(_ct);
    });
    s.parentNode.insertBefore(wzrk, s);
  })();
`;

export const fb_pixel = `
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.addEventListener("load",function(){var e=new CustomEvent("fb_pixel_loaded",{bubbles:!0});document.dispatchEvent(e)});
  s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  fbq('init','${environment.facebook_pixel}');
`;


export const blitzlamaScript = `
var exports = { __esModule: true };
var api_key = 'key_Bq8eCE068HEnR1G';
window._blitzQueue = window._blitzQueue || [];
function blitz() {
  _blitzQueue.push(arguments);
}
(function () {
  var a = document.createElement('script');
  a.type = 'text/javascript';
  a.async = !0;
  a.src = 'https://cdn.blitzllama.com/js/blitz.js';
  var b = document.getElementsByTagName('script')[0];
  b.parentNode.insertBefore(a, b);
})();
blitz('init', api_key);`;


export const verloop_script = `
  (function(w, d, s, u) {
    w.Verloop = function(c) { w.Verloop._.push(c) }; w.Verloop._ = []; w.Verloop.url = u;
    var h = d.getElementsByTagName(s)[0], j = d.createElement(s); j.async = true;
    j.src = 'https://ketto.verloop.io/livechat/script.min.js';
    h.parentNode.insertBefore(j, h);
    j.addEventListener('load', function() {
      var _ct = new CustomEvent('verloop_loaded', { bubbles: true });
      document.dispatchEvent(_ct);
    });
  })(window, document, 'script', 'https://ketto.verloop.io/livechat');
`;

export const microsoft_clarity = `
(function (c, l, a, r, i, t, y) {
  c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
  t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
  y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  t.addEventListener('load', function() {
    var _ct = new CustomEvent('clarity_loaded', { bubbles: true });
    document.dispatchEvent(_ct);
  });
})(window, document, "clarity", "script", '${environment.microsoft_clarity}');
`;
